import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSkipNextStyle0 = cosmosIconCss;

const CosmosIconSkipNext$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSkipNext extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c94477ae5c87168fe8fc8122578aa45c3fdfc9b9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9c22820f66f52b1faba18b1e541bfbdf3deb9434', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '555a1e691783315dcac20e56a03bb0dd1c041e3d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.995 4.5a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0-.5.5l-.005 13a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-13ZM6.386 17.836l6.455-6.443a.565.565 0 0 0 0-.786L6.386 4.164a.554.554 0 0 0-.786 0l-.387.387a.565.565 0 0 0 0 .786l5.668 5.658-5.668 5.668a.565.565 0 0 0 0 .786l.387.387a.553.553 0 0 0 .786 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSkipNextStyle0; }
}, [1, "cosmos-icon-skip-next", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-skip-next"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-skip-next":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSkipNext$1);
            }
            break;
    } });
}

const CosmosIconSkipNext = CosmosIconSkipNext$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSkipNext, defineCustomElement };
